/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Swap_Not_FoundInputs */

const en_us2_workout_swap_not_found = /** @type {(inputs: Workout_Swap_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This exercise isn't in today's workout.`)
};

const pt_br2_workout_swap_not_found = /** @type {(inputs: Workout_Swap_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este exercício não está no treino de hoje.`)
};

const es_419_workout_swap_not_found = /** @type {(inputs: Workout_Swap_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este ejercicio no está en el entrenamiento de hoy.`)
};

const pt_pt2_workout_swap_not_found = /** @type {(inputs: Workout_Swap_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este exercício não está no treino de hoje.`)
};

const fr_fr2_workout_swap_not_found = /** @type {(inputs: Workout_Swap_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cet exercice n'est pas dans la séance d'aujourd'hui.`)
};

const de_de2_workout_swap_not_found = /** @type {(inputs: Workout_Swap_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Übung ist nicht im heutigen Training.`)
};

const it_it2_workout_swap_not_found = /** @type {(inputs: Workout_Swap_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questo esercizio non è nell'allenamento di oggi.`)
};

/**
* | output |
* | --- |
* | "This exercise isn't in today's workout." |
*
* @param {Workout_Swap_Not_FoundInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_swap_not_found = /** @type {((inputs?: Workout_Swap_Not_FoundInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Swap_Not_FoundInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_swap_not_found(inputs)
	if (locale === "es-419") return es_419_workout_swap_not_found(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_swap_not_found(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_swap_not_found(inputs)
	if (locale === "de-DE") return de_de2_workout_swap_not_found(inputs)
	if (locale === "it-IT") return it_it2_workout_swap_not_found(inputs)
	return en_us2_workout_swap_not_found(inputs)
});
export { workout_swap_not_found as "workout-swap.not_found" }